// extracted by mini-css-extract-plugin
export default {"buttonSizeContainer":"faqSize_buttonSizeContainer__rTpeF","buttonSize":"faqSize_buttonSize__KsNj3","selected":"faqSize_selected__P4xo+"};